import { createDocumentMentionMarkdown } from 'src/components/ai/chat/ChatPanel/ChatEditor/ChatEditorMention/document-mention-markdown';

/** What the playbooks page puts in chat when the user starts without a source file. */
export function createNewPlaybookPrompt(): string {
  return 'Generate a new playbook **[attach files and describe the agreement type, party, and priorities here]**.';
}

/**
 * What the editor's "Generate a playbook" card puts in the chat input: the
 * document as a mention chip, then the request. It is the same message a user
 * types on the chat page, so the same agent, the same questions about party
 * and priorities, and the same plan approval follow, whichever page the user
 * started from.
 */
export function createGeneratePlaybookPrompt({
  documentId,
  documentName,
}: {
  documentId: string;
  documentName: string;
}): string {
  const mention = createDocumentMentionMarkdown({ displayText: documentName, documentId });
  return `Generate a playbook from this document ${mention} **[add additional context here or delete]**.`;
}
